module.exports = __webpack_public_path__ + "static/media/img-473f086d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/pdr-logo.png
// module id = 5297
// module chunks = 39